import { render, staticRenderFns } from "./EditColorBtn.vue?vue&type=template&id=6b390e37&scoped=true&"
import script from "./EditColorBtn.vue?vue&type=script&lang=js&"
export * from "./EditColorBtn.vue?vue&type=script&lang=js&"
import style0 from "./EditColorBtn.vue?vue&type=style&index=0&id=6b390e37&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b390e37",
  null
  
)

export default component.exports